<template>
  <div>
    <b-row>
      <a-tooltip placement="top" v-if="properties.create">
        <template slot="title">
          <span>Crear usuario</span>
        </template>
        <router-link :to="{name: 'usersCreate'}"  style="position: absolute;right:5em;z-index:10;" v-if="hasPermission([
          consts.permissions.CREATE_USER,
          consts.permissions.UPDATE_USER,
          consts.permissions.UPDATE_USER_PHOTO,
          consts.permissions.UPDATE_USER_CODE_CARD,
        ])">
          <a-button type="primary" shape="circle" icon="plus" class="ml-3"/>
        </router-link>
      </a-tooltip>
      <a-dropdown placement="bottomRight" style="position: absolute;right:1em;z-index:10;" :trigger="['click']" v-if="properties.databaseReport && (activeModule || massiveCheck)">
        <button type="button" class="btn btn-light">
          <i class="fe fe-more-vertical" />
        </button>
        <a-menu slot="overlay">
          <template v-if="activeModule">
            <a-menu-item>
              <a-button type="link" id="2" class="w-100 text-left" @click="openModalSelectYear('ENROLLMENT_STUDENTS')" icon="download">Descargar Reporte con estados de Matrícula</a-button>
            </a-menu-item>
            <a-menu-item>
              <a-button type="link" id="3" class="w-100 text-left" @click="downloadSignatures()" icon="download">Descargar Reporte de Firmas Diligenciadas</a-button>
            </a-menu-item>
          </template>
            <a-menu-item v-if="massiveCheck">
              <a-button type="link" id="3" @click="openModalMassiveRecharge()" icon="dollar">Recarga masiva</a-button>
            </a-menu-item>
          <template>
          </template>
        </a-menu>
      </a-dropdown>
      <div class="col">
        <h5 class="mb-4">
          <strong>Lista de usuarios</strong>
          <a-tooltip placement="top" v-if="properties.create">
            <template slot="title">
              <span>Ver filtros</span>
            </template>
            <a-button class="ml-2" type="primary" @click="form.visibleCollapse = !form.visibleCollapse"  shape="circle" icon="search"/>
          </a-tooltip>
        </h5>
      </div>
    </b-row>
    <b-collapse id="collapse-1" class="mt-2" v-model="form.visibleCollapse">
      <b-form>
        <b-row align-v="center">
          <div class="col-md-2" v-if="properties.searchOptions.role">
            <b-form-group id="input-group-1" label="Rol:" label-for="input-1">
              <b-form-select v-model="form.role" :options="roles"></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-2 align-items-center" v-show="visibleCheckbox">
            <b-form-checkbox
              id="input-group-7"
              v-model="checkEnrolled"
              name="checkbox-1"
            >
              Estado de Matricula
            </b-form-checkbox>
          </div>
          <div :class="properties.searchOptions.role ? 'col-md-2': 'col-12 col-sm-6 col-lg-4 col-xl-3'" v-if="properties.searchOptions.cc">
            <b-form-group id="input-group-2" label="Identificación:" label-for="input-2">
              <b-form-input id="input-2" v-model="form.nip" placeholder="Ingrese el nip"></b-form-input>
            </b-form-group>
          </div>
          <div :class="properties.searchOptions.role ? 'col-md-4': 'col-12 col-sm-12 col-lg-8 col-xl-6'" v-if="properties.searchOptions.name">
            <b-form-group id="input-group-3" label="Nombres o apellidos:" label-for="input-3">
              <b-form-input id="input-3" v-model="form.name" placeholder="Ingrese los nombres o apellidos"></b-form-input>
            </b-form-group>
          </div>
          <div :class="properties.searchOptions.role ? 'col-md-2': 'col'" v-if="properties.searchOptions.grade">
            <b-form-group id="input-group-5" label="Grado:" label-for="input-5">
              <b-form-select v-model="form.grade" :options="grades"></b-form-select>
            </b-form-group>
          </div>
          <div :class="properties.searchOptions.role ? 'col-md-2': 'col-12 col-sm-6 col-lg-4 col-xl-3'" v-if="properties.searchOptions.codeCard">
            <b-form-group id="input-group-code-card" label="Código de tarjeta:" label-for="input-code-card">
              <b-form-input id="input-code-card" v-model="form.codeCard" placeholder="Ingrese código de tarjeta"></b-form-input>
            </b-form-group>
          </div>
          <div :class="properties.searchOptions.role ? 'col-md-2': 'col'" v-if="properties.searchOptions.email">
            <b-form-group id="input-group-6" label="Email:" label-for="input-2">
              <b-form-input id="input-6" v-model="form.email" placeholder="Ingrese el email"></b-form-input>
            </b-form-group>
          </div>
        </b-row>
      </b-form>
    </b-collapse>
    <b-row v-if="properties.create">
      <div class="col">
        <b-form inline>
          <b-form-group id="input-group-7" label-for="input-7">
            <b-form-input id="input-7" ref="code" autofocus v-model="codeCard" placeholder="Código de tarjeta" onkeypress="return event.keyCode != 13;"></b-form-input>
          </b-form-group>
          <b-button variant="primary" class="my-3 mx-2" @click="cleanCodeCard()">Limpiar</b-button>
        </b-form>
      </div>
    </b-row>
    <b-row>
      <div class="col">
        <b-table striped hover :fields="columns" :items="users" head-variant="light" responsive v-if="users.length > 0">
          <template #cell(name)="user">
            {{ getName(user.item) }}
          </template>
          <template #cell(lastName)="user">
            {{ getLastName(user.item) }}
          </template>
          <template #cell(balance)="user" v-if="properties.columns.balance">
            {{ currencyFormat(user.item.balance) }}
          </template>
          <template #cell(actions)="user">
            <div>
              <a-tooltip placement="top" v-if="properties.actions.information">
                <template slot="title">
                  <span>Ver información</span>
                </template>
                <button type="button" @click="() => openModal(user.item.id)" class="btn btn-light mr-2">
                  <i class="fa fa-eye" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top" v-if="properties.actions.select">
                <template slot="title">
                  <span>Seleccionar</span>
                </template>
                <button type="button" @click="() => sendCodeCard(user.item.id)" class="btn btn-light mr-2">
                  <i class="fa fa-check" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top" v-if="properties.actions.selectSU">
                <template slot="title">
                  <span>Seleccionar</span>
                </template>
                <button type="button" @click="() => selectSU(user.item.id)" class="btn btn-light mr-2">
                  <i class="fa fa-check" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top" v-if="properties.actions.edit">
                <template slot="title">
                  <span>Editar</span>
                </template>
                <router-link :to="{ name: 'usersEdit', params: { idUser: user.item.id } }" class="btn btn-light mr-2" v-if="hasPermission([
                  consts.permissions.UPDATE_USER,
                  consts.permissions.UPDATE_USER_PHOTO,
                  consts.permissions.UPDATE_USER_CODE_CARD,
                ])">
                  <i class="fa fa-pencil text-blue" />
                </router-link>
              </a-tooltip>
              <a-tooltip placement="top" v-if="properties.actions.rechargeBalance">
                <template slot="title">
                  <span>Recargar Saldo</span>
                </template>
                <button type="button" v-on:click="openModalRecharge(user.item.id)" class="btn btn-light mr-2" v-if="hasPermission([
                  consts.permissions.CREATE_RECHARGE,
                ])">
                  <i class="fa fa-credit-card" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top" v-if="properties.actions.rechargeCombos">
                <template slot="title">
                  <span>Recargar {{comboName}}s</span>
                </template>
                <button v-show="comboCheck" type="button" v-on:click="openModalCombo(user.item.id)" class="btn btn-light mr-2" v-if="hasPermission([
                  consts.permissions.CREATE_RECHARGE,
                ])">
                  <i class="fa fa-cutlery" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top" v-if="properties.actions.passwordReset">
                <template slot="title">
                  <span>Restablecer contraseña</span>
                </template>
                <button type="button" v-on:click="openModalResetPassword(user.item)" class="btn btn-light mr-2" v-if="hasPermission([
                  consts.permissions.UPDATE_USER_PASSWORD,
                ])">
                  <i class="fa fa-lock" />
                </button>
              </a-tooltip>
              <a-tooltip placement="top" v-if="properties.actions.startEnrollement && user.item.idGrade && hasPermission([consts.permissions.CREATE_ACADEMIC_MANAGEMENT])">
                <template slot="title">
                  <span>Iniciar matrícula</span>
                </template>
                <button type="button" v-on:click="startEnrollement(user.item)" class="btn btn-light mr-2">
                  <i class="fa fa-address-book-o"></i>
                </button>
              </a-tooltip>
              <!-- && [consts.rolesText.ADMIN, consts.rolesText.ADMIN_ACADEMICO, consts.rolesText.GESTOR_ACADEMICO].includes(user.role) -->
              <!-- <a-tooltip placement="top">
                <template slot="title">
                  <span>Descargar reporte de notas</span>
                </template>
                <button type="button" v-on:click="openModalDownloadGrades(user.item)" class="btn btn-light mr-2" v-if="hasRole(['SU', 'ADMIN', 'ADMIN_ACADEMICO', 'GESTOR_ACADEMICO'])">
                  <i class="fa fa-list-ol" />
                </button>
              </a-tooltip> -->
              <!-- <a-tooltip placement="top">
                <template slot="title">
                  <span>Descargar reporte de notas individual</span>
                </template>
                <button type="button" v-on:click="openModalDownloadFinalReport(user.item)" class="btn btn-light mr-2"
                  v-if="hasRole(['ADMIN', 'ADMIN_ACADEMICO', 'COORDINADOR', 'GESTOR_ACADEMICO'])">
                  <i class="fa fa-file-powerpoint-o" />
                </button>W
              </a-tooltip> -->
            </div>
          </template>
        </b-table>
        <empty-table v-else />
      </div>
    </b-row>
    <b-row >
      <b-col>
        <b-pagination
          v-model="pagination.currentPage"
          :total-rows="pagination.rows"
          :per-page="pagination.perPage"
          @input="optionSearch()"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
      <b-col class="text-right">
        {{ pagination.rows }} resultados
      </b-col>
    </b-row>
    <b-modal id="user-details" no-enforce-focus scrollable ref="modal" title="Información del usuario" hide-footer size="lg" @hidden="onHidden">
      <b-row class="justify-content-center mb-2">
        <b-col>
          <img
            :src="`${userSelected.pathAvatar}?tr=w-300`"
            @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
            width="200" alt="..." class="img-thumbnail img-fluid"
            style="display: block; margin-left: auto; margin-right: auto;"><br/>
        </b-col>
        <b-col sm="12" md="6" class="m-auto">
          <b-row class="m-auto">
            <b class="mr-1">Nombre:</b> {{ this.userSelected.fullName }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Estado de Matricula: </b> {{ this.userSelected.isEnrolled }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Saldo: </b> {{ this.userSelected.balance }}
          </b-row>
          <b-row v-if="comboCheck" class="m-auto">
            <b class="mr-1">{{ comboName[0].toUpperCase() + comboName.slice(1).toLowerCase() }}s: </b> {{ this.userSelected.combos }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Identificación: </b> {{ this.userSelected.nip }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Código de tarjeta: </b> {{ this.userSelected.codeCard }}
          </b-row>
          <b-row class="m-auto" v-if="this.userSelected.roles.includes(consts.rolesText.ESTUDIANTE)">
            <b class="mr-1">Grado: </b> {{ this.userSelected.currentGrade.name }}
          </b-row>
          <b-row class="m-auto" v-if="this.userSelected.roles.includes(consts.rolesText.ESTUDIANTE)">
            <b class="mr-1">Grupo: </b> {{ this.userSelected.currentGroup }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Teléfono: </b> {{ this.userSelected.phone }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Email: </b> {{ this.userSelected.email }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Role: </b> {{ this.userSelected.roles }}
          </b-row>
          <b-row class="m-auto" v-if="this.userSelected.roles.includes(consts.rolesText.PADRE_MADRE) ">
            <b class="mr-1">Hijo(a): </b>
            <div v-if="userSelected.sons">
              <ul class="list-inline my-0" v-for="(son, i) in userSelected.sons" :key='i'>
                <li>{{ son }}</li>
              </ul>
            </div>
            <div v-else> Sin hijos</div>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="5">
          <b-button block squared variant="outline-success" class="btn-rounded mb-2" v-on:click="downloadRechargesSalesReport()">
            <i class="fe fe-download mr-1"></i>
            Descargar reporte de recargas y ventas
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="this.userSelected.roles.includes(consts.rolesText.ESTUDIANTE)">
        <b-col md="5">
          <b-button block squared variant="outline-success" class="btn-rounded mb-2" v-on:click="gettingFullInfo()">
            <i class="fa fa-address-card mr-1"></i>
            Consultar información completa
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="this.userSelected.roles.includes(consts.rolesText.ESTUDIANTE) && properties.user.downloadEnrollmentSheet">
        <b-col md="5">
          <b-button block squared variant="outline-success" class="btn-rounded mb-2" v-on:click="openModalSelectYear('ENROLLMENT_SHEET')">
            <i class="fa fa-address-card mr-1"></i>
            Descargar ficha de matricula
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="this.userSelected.roles.includes(consts.rolesText.ESTUDIANTE) && properties.user.downloadEnrollmentSheet">
        <b-col md="5">
          <b-button block squared variant="outline-success" class="btn-rounded mb-2" v-on:click="openModalSelectYear('CERTIFICATE')">
            <i class="fa fa-file-text mr-1"></i>
            Descargar certificado
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="hasPermission([consts.permissions.DELETE_USER]) && properties.user.deleteUser">
        <b-col md="5">
          <b-button block squared variant="outline-danger" class="btn-rounded mb-2" v-on:click="forceDeleteStudent(userSelected)">
            <i class="fa fa-user-times mr-1"></i>
            Eliminación total del usuario
          </b-button>
        </b-col>
      </b-row>
      <!--  -->
      <b-collapse id="fullInfo-collapse" class="mt-2" v-model="fullInfoVisible">
        <b-row class="m-auto">
          <a-divider> Información del estudiante </a-divider>
          <b-col v-for="(value, key, index) in userSelectedFullInfo[0]" v-bind:key="key.id" lg="6" md="15" sm="15">>
            <b>{{ dataQuestions[0][index] }}:</b> {{ value }}
          </b-col>
          <a-divider> Información de la madre </a-divider>
          <b-col v-for="(value, key, index) in userSelectedFullInfo[1]" v-bind:key="key.id" lg="6" md="15" sm="15">>
            <b>{{ dataQuestions[1][index] }}:</b> {{ value }}
          </b-col>
          <a-divider> Información del padre </a-divider>
          <b-col v-for="(value, key, index) in userSelectedFullInfo[2]" v-bind:key="key.id" lg="6" md="15" sm="15">>
            <b>{{ dataQuestions[2][index] }}:</b> {{ value }}
          </b-col>
          <a-divider> Información del acudiente </a-divider>
          <b-col v-for="(value, key, index) in userSelectedFullInfo[3]" v-bind:key="key.id" lg="6" md="15" sm="15">>
            <b>{{ dataQuestions[3][index] }}:</b> {{ value }}
          </b-col>
        </b-row>
      </b-collapse>
      <b-collapse id="fullInfo-collapse" class="mt-2" v-model="notFoundVisible">
        <b-row>
          <b-col>
            <b-button block squared disabled variant="outline-warning" class="btn-rounded mb-2">
              <i class="fe fe-x-square mr-1"></i>
              No se han encontrado coincidencias
            </b-button>
          </b-col>
        </b-row>
      </b-collapse>
    </b-modal>
    <b-modal id="delete-details" no-enforce-focus ref="modal" title="Resumen de la eliminación" hide-footer size="lg" @hidden="onHidden">
      <b-row class="justify-content-center mb-1">
        <b style="font-size: 1.3em;">El usuario fue eliminado exitosamente <i class="fa fa-check text-green" /></b>
      </b-row>
      <b-row class="justify-content-center mb-2" v-for="(value, key) in userDeletedInfo" v-bind:key="key.id">
        <b>{{ value }} </b>
      </b-row>
    </b-modal>
    <b-modal id="recharge-card" ref="modal" title="Recargar tarjeta eroo" hide-footer @hidden="onHidden">
      <b-row class="justify-content-center">
        <b-col>
          <img
            :src="`${userSelected.pathAvatar}?tr=w-300`"
            @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
            width="200" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="6">
          <b>Nombre:</b> {{ this.userSelected.fullName }}
        </b-col>
        <b-col sm="12" md="6">
          <b>Role:</b> {{ this.userSelected.roles }}
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="6">
          <b>Identificación:</b> {{ this.userSelected.nip }}
        </b-col>
        <b-col sm="12" md="6" v-show="this.userSelected.idGrade">
          <b>Grado:</b> {{ this.userSelected.currentGrade.name }}
        </b-col>
      </b-row>
      <b-row v-show="!isComboSelected" style="padding-top: 3em;">
        <b-col style="font-size: 1.5em;">
          <b>Saldo actual:</b> {{ this.currencyFormatBalance }}
        </b-col>
      </b-row>
      <b-row v-show="isComboSelected" style="padding-top: 3em;">
        <b-col style="font-size: 1.5em;">
          <b>Número de {{ comboName }}s recargados:</b> {{ this.userSelected.combos }}
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Tipo de recarga:">
            <b-form-radio-group
              v-model="typeToCharge"
              :options="options"
              value-field="item"
              text-field="name"
              disabled-field="notEnabled"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="isComboSelected">
        <b-col sm="10" md="10" lg="10">
          <b-form-group id="input-group-8" :label="`${comboName}s a recargar:`" label-for="input-8">
            <b-input-group>
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fa fa-cutlery text-blue" /></span>
              </div>
              <b-form-input v-model="combosToCharge" style="font-size: 2em;" class="form-input input-lg border-dark" type="number" min="0"></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="!isComboSelected">
        <b-col lg="15" class="pl-3">
          <b-form-group id="input-group-9" label="Valor a recargar:" label-for="input-9">
            <b-input-group>
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fa fa-money text-blue" /></span>
              </div>
              <money v-model="valueToCharge" v-bind="money" style="font-size: 2em;" class="form-input input-lg"></money>
              <!-- <b-form-input type="text" id="input-8" v-model.lazy="valueToCharge" v-money="money" placeholder="Saldo" style="font-size: 2em;"></b-form-input> -->
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="3" style="font-size: 1.5em;">
          <b-button type="submit" variant="primary" class="my-3 mx-2" @click="chargeCard()" :disabled="!chargeActiveButton">Recargar</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
           <div style="color: indianred; margin-top: -5em;">{{ this.msgValueToChargeValidation }}</div>
        </b-col>
      </b-row>
      <hr>
      <b-row class="pull-right">
        <b-col>
          <b-form>
            <b-button @click="$bvModal.hide('recharge-card')" variant="light" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="massive-recharge" ref="modal" title="Recargar masiva" hide-footer @hidden="onHidden2">
      <b-tabs content-class="mt-3">
        <b-tab title="Saldo" active>
          <b-row>
            <b-col>
              <b-form-group label="Tipo de recarga:">
                <b-form-radio-group
                  v-model="massiveRechargeData.balance.type"
                  :options="options"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <b-col>
                <b-form-group id="input-group-1">
                  <label for="input-1">Roles a recargar:</label>
                  <multiselect v-model="massiveRechargeData.balance.roles" :options="roles" :multiple="true" :taggable="true" label="text" track-by="value"
                    select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
                    placeholder="Seleccione una opción">
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
          <b-row>
            <b-col lg="15" class="pl-3">
              <b-form-group id="input-group-9" label="Valor a recargar:" label-for="input-9">
                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-money text-blue" /></span>
                  </div>
                  <money v-model="massiveRechargeData.balance.value" v-bind="money" style="font-size: 2em;" class="form-input input-lg"></money>
                  <!-- <b-form-input type="text" id="input-8" v-model.lazy="valueToCharge" v-money="money" placeholder="Saldo" style="font-size: 2em;"></b-form-input> -->
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="¿Reiniciar el saldo existente?">
                <b-form-radio-group
                  v-model="massiveRechargeData.balance.resetValues"
                  :options="options2"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <b-col>
                <div style="color: indianred; margin-top: -5em;">{{ this.msgValueToChargeValidation }}</div>
              </b-col>
            </b-row>
          <b-row>
            <b-col cols="12" sm="9" style="font-size: 1.5em;">
              <b-button type="submit" variant="primary" class="my-3 ml-2" @click="massiveRecharge(0)" :disabled="massiveRechargeData.balance.value < 50 || isLoading">Recargar</b-button>
              <b-button @click="$bvModal.hide('massive-recharge')" variant="light" size="sm" class="ml-1 mb-3 mt-3">Cancelar</b-button>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="`${comboName[0].toUpperCase() + comboName.slice(1).toLowerCase()}s`" v-if="comboCheck">
          <template v-if="comboCheck">
            <b-row>
              <b-col>
                <b-form-group label="Tipo de recarga:">
                  <b-form-radio-group
                    v-model="massiveRechargeData.combo.type"
                    :options="options"
                    value-field="item"
                    text-field="name"
                    disabled-field="notEnabled"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="input-group-1">
                  <label for="input-1">Roles a recargar:</label>
                  <multiselect v-model="massiveRechargeData.combo.roles" :options="roles" :multiple="true" :taggable="true" label="text" track-by="value"
                    select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
                    placeholder="Seleccione una opción">
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="10" md="10" lg="10">
                <b-form-group id="input-group-8" :label="`${comboName[0].toUpperCase() + comboName.slice(1).toLowerCase()}s a recargar:`" label-for="input-8">
                  <b-input-group>
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fa fa-cutlery text-blue" /></span>
                    </div>
                    <b-form-input v-model="massiveRechargeData.combo.value" style="font-size: 2em;" class="form-input input-lg border-dark" type="number" min="0"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label="`¿Reiniciar el número de ${comboName[0].toUpperCase() + comboName.slice(1).toLowerCase()}s existentes?`">
                  <b-form-radio-group
                    v-model="massiveRechargeData.combo.resetValues"
                    :options="options2"
                    value-field="item"
                    text-field="name"
                    disabled-field="notEnabled"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div style="color: indianred; margin-top: -5em;">{{ this.msgValueToChargeValidation }}</div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="9" style="font-size: 1.5em;">
                <b-button type="submit" variant="primary" class="my-3 ml-2" @click="massiveRecharge(1)" :disabled="massiveRechargeData.combo.value < 1 || isLoading">Recargar</b-button>
                <b-button @click="$bvModal.hide('massive-recharge')" variant="light" size="sm" class="ml-1 mb-3 mt-3">Cancelar</b-button>
              </b-col>
            </b-row>
          </template>
        </b-tab>
      </b-tabs>
    </b-modal>
    <b-modal id="reset-password" ref="modal" title="Restablecer contraseña" hide-footer>
      <b-row>
        <b-col sm="12">
          <b>Nombre:</b> {{ this.userToResetPassword.fullName }}
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b>Identificación:</b> {{ this.userToResetPassword.cc }}
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-input-group>
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-key text-blue" /></span>
            </div>
            <b-form-input type="text" id="input-8" v-model="newPassword" placeholder="Nueva contraseña" :disabled="passwordIsNip=='accepted'"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col cols="12" sm="3">
          <b-button type="submit" variant="primary" class="" @click="resetPassword()" :disabled="!chargeActiveButton">Restablecer</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-checkbox id="checkbox-1" v-model="passwordIsNip" name="checkbox-1" value="accepted" unchecked-value="not_accepted">
            Usar # de Identificación como contraseña
          </b-form-checkbox>
        </b-col>
      </b-row>
      <hr>
      <b-row class="pull-right">
        <b-col>
          <b-form>
            <b-button @click="$bvModal.hide('reset-password')" variant="light" size="sm" class="mr-2 mb-3 mt-3">Cerrar</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="final-report" ref="modal" title="Descargar reporte final" hide-footer>
      <b-row>
        <b-col sm="12">
          <b>Nombre:</b> {{ this.userToDownloadFinalReport.fullName}}
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-form-checkbox
            id="checkbox-1"
            v-model="messageCheck"
            name="checkbox-1"
            value="true"
            unchecked-value="false"
          >
            Agregar mensajes de reporte final
          </b-form-checkbox>
        </b-col>
        <b-col cols="12">
          <b-button type="submit" variant="primary" class="" @click="downloadFinalReport()">Descargar</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row class="pull-right">
        <b-col>
          <b-form>
            <b-button @click="$bvModal.hide('final-report')" variant="light" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="yearSelect" ref="modal" :title="modalTitle" hide-footer size="sm" @hidden="cleanChecks">
      <b-row>
        <b-col sm="3">
          <label style="margin-top: 0.4em;">Año: </label>
        </b-col>
        <b-col sm="8">
          <b-form-select id="year-select" v-model="yearSelection" :options="yearOptions"></b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="reportType === 'CERTIFICATE'">
        <b-col sm="5">
          <label style="margin-top: 0.4em;">¿Parcial?</label>
        </b-col>
        <b-col sm="2" align-self="center">
          <b-form-checkbox style="margin-top: 0.4em;" id="check-partial" v-model="isPartial" switch></b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="reportType === 'CERTIFICATE'">
        <b-col sm="5">
          <label style="margin-top: 0.4em;">Mensaje de reporte final</label>
        </b-col>
        <b-col sm="2" align-self="center">
          <b-form-checkbox style="margin-top: 0.4em;" id="message-check" v-model="messageCheck" switch></b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="4">
          <b-button @click="$bvModal.hide('yearSelect')" variant="secondary" size="sm" class="mb-3 mt-3">Cancelar</b-button>
          <b-button v-if="reportType === 'ENROLLMENT_STUDENTS'" @click="downloadEnrolledStudents()" variant="primary">Descargar</b-button>
          <b-button v-if="reportType === 'ENROLLMENT_SHEET'" @click="downloadEnrollmentSheet()" variant="primary">Descargar</b-button>
          <b-button v-if="reportType === 'CERTIFICATE'" @click="downloadCertificate()" variant="primary">Descargar</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import { mapState } from 'vuex'
import axios from 'axios'
import { Money } from 'v-money'
import { consts, currencyFormat, currencyFormatPesos, hasPermission, showErrorMessage } from '@/services/utilities'
import store from 'store'
import moment from 'moment'
import Swal from 'sweetalert2'
import emptyTable from '@/components/custom/cardEmptyList'

// import moment from 'moment'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'userList',
  components: { Money, emptyTable },
  props: {
    properties: {
      type: Object,
    },
  },
  data() {
    return {
      yearOptions: [],
      options: [
        { item: '1', name: 'Efectivo' },
        { item: '2', name: 'Transferencia' },
      ],
      options2: [
        { item: true, name: 'Si' },
        { item: false, name: 'No' },
      ],
      isLoading: false,
      yearSelection: null,
      activeModule: false,
      checkEnrolled: false,
      visibleCheckbox: false,
      actualPeriod: false,
      fullInfoVisible: false,
      notFoundVisible: false,
      userDeletedInfo: '',
      userDeletedStatus: true,
      msgValueToChargeValidation: '',
      typeToCharge: '',
      modalTitle: '',
      valueToCharge: 0,
      combosToCharge: 0,
      reportType: false,
      isPartial: false,
      isComboSelected: false,
      chargeActiveButton: true,
      generatingReport: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$',
        suffix: '',
        precision: 0,
        masked: false, /* doesn't work with directive */
      },
      columns: [
        { key: 'lastName', label: 'Apellidos' },
        { key: 'name', label: 'Nombres' },
      ],
      codeCard: '',
      form: {
        role: null,
        nip: '',
        name: '',
        lastName: '',
        grade: null,
        codeCard: '',
        email: '',
        visibleCollapse: false,
      },
      roles: [
        { value: null, text: 'Seleccione un rol' },
      ],
      userReport: {},
      grades: [],
      users: [],
      userSelected: {
        nip: '',
        name: '',
        lastName: '',
        grade: null,
        email: '',
        balance: '',
        phone: '',
        currentGrade: '',
        roles: '',
        pathAvatar: '',
        combos: '',
      },
      userSelectedFullInfo: [],
      userToResetPassword: {},
      newPassword: '',
      passwordIsNip: 'not_accepted',
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      typingTimer: '',
      accessToken: '',
      userToDownloadFinalReport: {},
      messageCheck: false,
      finalMessageReport: '',
      dataQuestions: [
        ['Nacionalidad', 'Lugar de nacimiento', 'Sexo', 'Fecha de nacimiento', 'Tipo de identificación',
          'Lugar de expedición', 'Grupo sanguíneo', 'Entidad promotora de salud EPS',
          'Estatura (cm)', 'Masa corporal (kg)', 'Dirección residencia', 'Barrio', 'Ciudad', 'Estrato',
          'Número de hermanos', '¿Con quién permanece más tiempo?', 'Historia clinica (alergias, cirugias, etc)',
          'Observaciones', 'Área de estudio preferida', 'Área de estudio con mayor dificultad',
          'Estado civil de los padres', '¿Quién es el acudiente?'],
        ['Nombres madre', 'Apellidos madre', 'No. Identificación madre', 'Tipo de documento', 'Fecha de expedición del documento', 'Identificación expedida en', 'Email madre',
          'Dirección de residencia madre', 'Ciudad de residencia', 'Teléfono madre', 'Ocupación madre', 'Trabaja como',
          'Empresa de la madre', 'Teléfono de la empresa',
        ],
        ['Nombres padre', 'Apellidos padre', 'No. Identificación padre', 'Tipo de documento', 'Fecha de expedición del documento', 'Identificación expedida en', 'Email padre',
          'Dirección de residencia padre', 'Ciudad de residencia', 'Teléfono padre', 'Ocupación padre', 'Trabaja como',
          'Empresa del padre', 'Teléfono de la empresa',
        ],
        [
          'Nombres acudiente', 'Apellidos acudiente', 'No. Identificación acudiente', 'Email acudiente',
          'Dirección de residencia acudiente', 'Ciudad de residencia', 'Teléfono acudiente', 'Trabaja como',
        ],
      ],
      comboCheck: false,
      comboName: '',
      consts: consts,
      massiveCheck: false,
      massiveRechargeData: {
        combo: {
          roles: [],
          type: '1',
          value: 0,
          resetValues: false,
        },
        balance: {
          roles: [],
          type: '1',
          value: 0,
          resetValues: false,
        },
      },
    }
  },
  computed: {
    ...mapState(['user']),
    currencyFormatBalance: function () {
      return currencyFormat(this.userSelected.balance)
    },
  },
  watch: {
    valueToCharge: function(val) {
      this.chargeActiveButton = false
      if (val % 50 !== 0) { // es multiplo de 50
        this.msgValueToChargeValidation = 'El valor a recargar debe ser multiplo de $50'
        return
      }
      if (val <= 0) {
        this.msgValueToChargeValidation = 'El valor a recargar debe ser mayor a cero (0).'
        return
      }
      this.msgValueToChargeValidation = ''
      this.chargeActiveButton = true
    },
    combosToCharge: function(val) {
      this.chargeActiveButton = false
      if (val <= 0) {
        this.msgValueToChargeValidation = 'El valor a recargar debe ser mayor a cero (0).'
        return
      }
      this.msgValueToChargeValidation = ''
      this.chargeActiveButton = true
    },
    codeCard: function () {
      this.getByCodeCard()
    },
    'form.role': function (value) {
      this.visibleCheckbox = value === 7
      this.checkEnrolled = value === 7
      this.getByCodeCard()
    },
    checkEnrolled: function (value) {
      this.getByCodeCard()
    },
    'form.nip': function () {
      this.getByCodeCard()
    },
    'form.name': function () {
      this.getByCodeCard()
    },
    'form.grade': function () {
      this.getByCodeCard()
    },
    'form.codeCard': function () {
      this.getByCodeCard()
    },
    'form.email': function () {
      this.getByCodeCard()
    },
    passwordIsNip: function (val) {
      if (val === 'accepted') {
        this.newPassword = this.userToResetPassword.cc
      }
    },
  },
  methods: {
    getName(user) {
      if (user !== false) {
        let fullName = user.firstName
        if (user.secondName !== null && user.secondName.length > 1) {
          fullName += ' ' + user.secondName
        }
        return fullName
      }
    },
    getLastName(user) {
      if (user !== false) {
        let fullName = user.firstLastName
        if (user.secondLastName !== null && user.secondLastName.length > 1) {
          fullName += ' ' + user.secondLastName
        }
        return fullName
      }
    },
    gettingFullInfo() {
      if (!this.fullInfoVisible) {
        apiClient.get(`/enrollments/${this.userSelected.id}`).then(response => {
          this.userSelectedFullInfo = response.data
          if (response.data) {
            this.fullInfoVisible = true
          } else {
            this.notFoundVisible = true
          }
        }).catch(err => {
          this.$notification.success({
            message: 'Ooops ocurrio un error',
            description: showErrorMessage(err),
          })
        })
      } else {
        this.fullInfoVisible = false
      }
    },
    downloadEnrolledStudents() {
      const endNameReport = moment(this.endDate).format('YYYY-MM-DD')
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        AccessToken: this.accessToken,
      }
      axios({
        url: `${process.env.VUE_APP_API_URL_V2}/enrollments/download-report`,
        params: {
          ...(this.yearSelection && { idYear: this.yearSelection }),
        },
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_estado_de_matrícula_${endNameReport}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
      })
    },
    downloadSignatures() {
      const endNameReport = moment(this.endDate).format('YYYY-MM-DD')
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        AccessToken: this.accessToken,
      }
      axios({
        url: process.env.VUE_APP_API_URL + '/enrollments/signature/download-report',
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_eroo_firmas_digitales_${endNameReport}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
      })
    },
    async sendCodeCard(idUser) {
      await this.getUser(idUser)
      this.$emit('getCodeCard', this.userSelected.codeCard, this.userSelected.roles)
    },
    async selectSU(idUser) {
      if (this.properties.isObserved) {
        this.$emit('selectSU', idUser)
      } else {
        await this.getUser(idUser)
        this.$emit('selectSU', this.userSelected.id)
      }
    },
    onHidden (e) {
      this.fullInfoVisible = false
      this.notFoundVisible = false
    },
    onHidden2 (e) {
      const types = ['combo', 'balance']
      for (const type of types) {
        this.massiveRechargeData[type].roles = []
        this.massiveRechargeData[type].type = '1'
        this.massiveRechargeData[type].value = 0
        this.massiveRechargeData[type].resetValues = false
      }
    },
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    currencyFormat: function (money) {
      return currencyFormatPesos(money)
    },
    async chargeCard() {
      // TODO Tiene role
      this.chargeActiveButton = false
      await apiClient2.post('/recharges', { idUser: this.userSelected.id, value: this.valueToCharge, rechargedCombos: this.combosToCharge, type: this.typeToCharge }).then(response => {
        this.userSelected.balance = response.data.newBalance
        this.$notification.success({
          message: 'Recarga exitosa',
        })
        this.search(null)
      }).catch(e => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(e),
        })
      })
      this.$bvModal.hide('recharge-card')
      this.valueToCharge = 20000
      this.chargeActiveButton = true
    },
    async openModalRecharge(idUser) {
      this.getUser(idUser)
      this.valueToCharge = 20000
      this.typeToCharge = '1'
      this.combosToCharge = 0
      this.isComboSelected = false
      this.$bvModal.show('recharge-card')
    },
    async openModalCombo(idUser) {
      this.getUser(idUser)
      this.isComboSelected = true
      this.valueToCharge = 0
      this.combosToCharge = 10
      this.$bvModal.show('recharge-card')
    },
    async openModal(idUser) {
      this.getUser(idUser)
      this.$bvModal.show('user-details')
    },
    openModalResetPassword(user) {
      this.userToResetPassword = user
      this.newPassword = ''
      this.passwordIsNip = 'not_accepted'
      this.$bvModal.show('reset-password')
    },
    openModalDownloadFinalReport(user) {
      if (user.idGrade === null) {
        this.$bvToast.toast('El usuario no es un estudiante', {
          title: 'Usuario inválido',
          variant: 'warning',
          autoHideDelay: 5000,
        })
      } else {
        this.userToDownloadFinalReport = user
        this.$bvModal.show('final-report')
      }
    },
    openModalDownloadGrades(user) {
      if (user.idGrade === null) {
        this.$bvToast.toast('El usuario no es un estudiante', {
          title: 'Usuario invalido',
          variant: 'warning',
          autoHideDelay: 5000,
        })
      } else {
        this.$bvModal.show('grades-report')
        this.userReport = user
      }
    },
    downloadReport() {
      this.generatingReport = true
      this.downloadGrades(this.userReport)
    },
    openModalSelectYear (type) {
      switch (type) {
        case 'ENROLLMENT_STUDENTS':
          this.modalTitle = 'Estado del proceso para matrículados'
          break
        case 'ENROLLMENT_SHEET':
          this.modalTitle = 'Ficha de matricula por año'
          break
        case 'CERTIFICATE':
          this.modalTitle = 'Certificado de estudio'
          break
        default:
          break
      }
      this.reportType = type
      apiClient.get('/years').then(response => {
        this.yearOptions = response.data.map(x => {
          return {
            value: x.id,
            text: x.name,
          }
        })
        this.yearOptions.unshift({ value: null, text: 'Seleccione un año' })
        this.$bvModal.show('yearSelect')
      }).catch(e => {
        Swal.fire('Ooops ocurrio un error', showErrorMessage(e), 'error')
      })
    },
    openModalMassiveRecharge() {
      this.$bvModal.show('massive-recharge')
    },
    massiveRecharge(selection) {
      this.isLoading = true
      const data = {
        key: selection,
        ...(selection === 1) ? this.massiveRechargeData.combo : this.massiveRechargeData.balance,
      }
      apiClient.post('/recharges/massive-recharge', data).then(response => {
        this.search()
        Toast.fire({
          icon: 'success',
          title: 'Recargas creadas exitosamente',
        })
        this.isLoading = false
      }).catch(e => {
        Toast.fire({
          icon: 'error',
          title: showErrorMessage(e),
        })
      })
      this.$bvModal.hide('massive-recharge')
    },
    downloadEnrollmentSheet() {
      let name = ''
      let yearName = ''
      for (const year of this.yearOptions) {
        if (year.value === this.yearSelection) {
          yearName = year.text
          name = `Ficha_de_Matricula_${this.userSelected.lastName}_${this.userSelected.name}_${year.text}.pdf`
        }
      }
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        AccessToken: this.accessToken,
      }
      axios({
        url: process.env.VUE_APP_API_URL + '/enrollments/enrollment-sheet/student/' + this.userSelected.id + '?yearSelected=' + this.yearSelection,
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name) // or any other extension
        document.body.appendChild(link)
        link.click()
      }).catch(e => {
        Swal.fire('', 'No se encontraron registros para el año ' + yearName, 'warning')
      })
    },
    downloadCertificate() {
      let name = ''
      let yearName = ''
      for (const year of this.yearOptions) {
        if (year.value === this.yearSelection) {
          yearName = year.text
          name = `Certificado_de_estudio_${this.userSelected.lastName}_${this.userSelected.name}.pdf`
        }
      }
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        AccessToken: this.accessToken,
      }
      axios({
        url: `${process.env.VUE_APP_API_URL_V2}/reports/academics/certificate/${this.userSelected.id}`,
        params: {
          ...(this.yearSelection && { idYear: this.yearSelection }),
          ...(this.isPartial && { isPartial: this.isPartial }),
          ...(this.messageCheck && { messageCheck: this.messageCheck }),
        },
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name) // or any other extension
        document.body.appendChild(link)
        link.click()
      }).catch(e => {
        Swal.fire('', 'No se encontraron registros para el año ' + yearName, 'warning')
      })
    },
    downloadFinalReport() {
      const headers = {
        Authorization: `Bearer ${store.get('accessToken')}`,
        AccessToken: store.get('accessToken'),
      }
      this.generatingReport = true
      const nameDocumento = `REPORTE_FINAL_${this.userToDownloadFinalReport.lastName}.pdf`
      axios({
        url: process.env.VUE_APP_API_URL + `/reports/academics/final-report/${this.userToDownloadFinalReport.id}/`,
        method: 'POST',
        responseType: 'blob', // Important
        headers: headers,
        data: {
          messageCheck: JSON.parse(this.messageCheck),
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', nameDocumento) // or any other extension
        document.body.appendChild(link)
        link.click()
        this.generatingReport = false
        this.$bvModal.hide('download-report-modal')
      })
    },
    forceDeleteStudent(user) {
      Swal.fire({
        title: '<strong>¿Desea eliminar al usuario?</strong>',
        html: '<b>Descripción:</b> Elimina al usuario de TODO el sistema(registros también serán eliminados)',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, retirar',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: '<strong>Digite el número de identificación del usuario</strong>',
            html: '<input type="text" id="inputMatch" v-model="inputMatchStudent" class="swal2-input" placeholder="No.Identificación">',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'No',
            preConfirm: () => {
              const inputMatch = Swal.getPopup().querySelector('#inputMatch').value
              if (!inputMatch) {
                Swal.showValidationMessage('Porfavor ingrese el número de identificación')
              }
              if (inputMatch !== user.nip) {
                Swal.showValidationMessage('Porfavor ingrese el número de identificación correcto')
              } else {
                return { inputMatch: inputMatch }
              }
            },
          }).then((response) => {
            if (response.isConfirmed) {
              this.inputMatch = response.value.inputMatch
              if (this.inputMatch === user.nip) {
                apiClient.delete('/users/' + user.id).then(status => {
                  let messageInfo = 'El usuario fue eliminado exitosamente'
                  for (const state in status.data) {
                    if (status.data[state].includes('Ocurrió un error')) {
                      this.userDeletedStatus = false
                      messageInfo = 'Se encontraron inconsistencias'
                    } else {
                      this.userDeletedStatus = true
                    }
                  }
                  Toast.fire({
                    icon: (this.userDeletedStatus) ? 'success' : 'warning',
                    title: messageInfo,
                  })
                  this.userDeletedInfo = status.data
                  this.search()
                  this.$bvModal.hide('user-details')
                  this.$bvModal.show('delete-details')
                }).catch(e => {
                  this.$notification.error({
                    message: 'Ooops ocurrió un error',
                    description: showErrorMessage(e),
                  })
                })
              }
            }
          })
        }
      })
    },
    resetPassword() {
      if (this.newPassword.length === 0) {
        this.$bvToast.toast('Debe ingresar una contraseña válida', {
          title: 'Error de validación',
          autoHideDelay: 5000,
        })
      } else {
        apiClient.patch(`/users/${this.userToResetPassword.id}/pw`, { pw: this.newPassword }).then(response => {
          this.$bvToast.toast('La contraseña fue restablecida correctamente.', {
            title: 'Contraseña restablecida',
            autoHideDelay: 5000,
          })
        }).catch(error => {
          this.$bvToast.toast(showErrorMessage(error), {
            title: 'Ooops ocurrió un error',
            autoHideDelay: 5000,
          })
        })
      }
    },
    async getUser(idUser) {
      await apiClient.get(`/users/${idUser}`).then(response => {
        this.userSelected = response.data
        this.userSelected.roles = this.userSelected.roles.map(rol => {
          return rol.name ? rol.name : ''
        }).join(', ')
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    getByCodeCard() {
      clearTimeout(this.typingTimer)
      if (this.properties.isObserved) {
        this.typingTimer = setTimeout(() => { this.listUserObserved() }, 500)
      } else {
        this.typingTimer = setTimeout(() => { this.search() }, 500)
      }
    },
    setDataUsers (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.users = data.rows.map((u) => {
          const grade = this.grades.find((g) => g.value === u.idGrade)
          u.grade = grade ? grade.text : 'NA'
          return u
        })
        this.pagination.rows = data.count ? data.count : 0
        if (this.$cookies.get('userSearch') && this.properties.create) {
          this.form = this.$cookies.get('userSearch')
          this.form.visibleCollapse = true
        }
      }
    },
    setDataGrades (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.grades = data.map(x => {
          return {
            value: x.id,
            text: 'COD' + x.id + ' - ' + x.name,
          }
        })
        this.grades.unshift({ value: null, text: 'Seleccione un grado' })
      }
    },
    setDataRoles (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        const roles = []
        data.forEach(i => roles.push({ value: i.id, text: i.name }))
        roles.unshift({ value: null, text: 'Seleccione un rol' })
        this.roles = roles
      }
    },
    setDataCombos (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.comboCheck = false
        for (const combo of data) {
          if (combo.key === consts.params.COMBO) {
            this.comboCheck = combo.active
            this.comboName = combo.value
            this.comboName = this.comboName[0].toUpperCase() + this.comboName.slice(1).toLowerCase()
          } else if (combo.key === consts.params.MASSIVE_RECHARGE) {
            this.massiveCheck = true
          }
        }
      }
    },
    cleanChecks() {
      this.yearSelection = null
      this.messageCheck = false
      this.isPartial = false
    },
    async cleanCodeCard () {
      this.codeCard = ''
      this.form = {
        role: null,
        nip: '',
        name: '',
        lastName: '',
        grade: null,
        email: '',
        visibleCollapse: false,
      }
      this.$refs.code.focus()
      await this.$cookies.remove('userSearch')
    },
    search() { // Guarda un grado llamando a la API
      this.$cookies.set('userSearch', this.form)
      let q = ''
      if (this.form.nip || this.form.name || this.form.grade || this.form.email || this.codeCard || this.form.codeCard) {
        q += '&q='
        if (this.form.nip) {
          q += 'cc!' + this.form.nip + ','
        }
        if (this.form.name) {
          q += 'name!' + this.form.name + ','
        }
        if (this.form.grade) {
          q += 'idGrade!' + this.form.grade + ','
        }
        if (this.form.email) {
          q += 'email!' + this.form.email + ','
        }
        if (this.codeCard) {
          q += 'codeCard!' + this.codeCard + ','
        }
        if (this.form.codeCard) {
          q += 'codeCard!' + this.form.codeCard + ','
        }
      }
      let role = ''
      if (this.form.role) {
        role += '&roles=' + this.form.role
        if (this.checkEnrolled) {
          role += '&enrolled=' + this.checkEnrolled
        }
      }
      q = q.substring(0, q.length - 1)
      apiClient2.get(`/users?fields=id,cc,firstName,secondName,firstLastName,secondLastName,idGrade,balance,codeCard&page=${this.pagination.currentPage - 1}&per_page=${this.pagination.perPage + q + role}`).then(response => {
        this.users = response.data.data.rows.map((u) => {
          const grade = this.grades.find((g) => g.value === u.idGrade)
          u.grade = grade ? grade.text : 'NA'
          return u
        })
        this.pagination.rows = response.data.data.count ? response.data.data.count : 0
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
    },
    downloadRechargesSalesReport() {
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        AccessToken: this.accessToken,
      }
      axios({
        // url: process.env.VUE_APP_API_URL + `/reports/sales/sales`,
        url: process.env.VUE_APP_API_URL_V2 + `/sales/reports/users/${this.userSelected.id}`,
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_de_ventas_${this.userSelected.lastName}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
      })
    },
    remove() { // Elimina un grado - Aun no implementado
      alert('Eliminado :D')
    },
    loadUserList() {
      this.accessToken = store.get('accessToken')
      apiClient.get('/schools/' + this.$store.state.user.idSchool).then(response => {
        this.activeModule = response.data.academicModule === true
      }).catch(e => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(e),
        })
        this.activeModule = false
      })
      function getRoles() {
        return apiClient.get('/roles')
      }

      function getCombos() {
        return apiClient2.get('/schoolParam/active')
      }

      function getGrades() {
        return apiClient2.get('/grades')
      }

      function getUsers() {
        return apiClient2.get('/users?fields=id,cc,name,lastName,idGrade,balance,combos,codeCard&page=0&per_page=10')
      }
      axios.all([getRoles(), getCombos(), getGrades(), getUsers()])
        .then(axios.spread((roles, combos, grades, users) => {
          this.setDataRoles(null, roles.data.results)
          this.setDataCombos(null, combos.data.data)
          this.setDataGrades(null, grades.data.data)
          this.setDataUsers(null, users.data.data)
        }))
        .catch(err => {
          this.setDataRoles(err, [])
          this.setDataCombos(err, [])
          this.setDataGrades(err, [])
          this.setDataUsers(err, [])
        })
    },
    listUserObserved() {
      const formSearch = {
        cc: this.form.nip,
        name: this.form.name,
        page: this.pagination.currentPage - 1,
        perPage: this.pagination.perPage,
      }
      apiClient2.get('/observations/users/all', { params: formSearch }).then(response => {
        this.users = response.data.data.map((u) => {
          const grade = this.grades.find((g) => g.value === u.idGrade)
          u.grade = grade ? grade.text : 'NA'
          return u
        })
        this.pagination.rows = response.data.data.length > 0 ? response.data.data[0].count : 0
      }).catch((error) => {
        Toast.fire({
          icon: 'warning',
          title: `${showErrorMessage(error)}`,
        })
      })
    },
    optionSearch() {
      if (this.properties.isObserved) {
        this.listUserObserved()
      } else {
        this.search()
      }
    },
    startEnrollement(user) {
      Swal.fire({
        title: 'Mensaje de confirmación',
        text: `¿Desea iniciar el proceso de matricula para el estudiante ${user.fullName}?`,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          apiClient2.post(`students-record/start-enrollement/${user.id}`).then(response => {
            Toast.fire({
              icon: 'success',
              title: `${response.data.message}`,
            })
          }).catch(error => {
            Toast.fire({
              icon: 'warning',
              title: `${showErrorMessage(error)}`,
            })
          })
        }
      })
    },
  },
  created() {
    if (this.properties.isObserved) {
      this.listUserObserved()
    } else {
      this.loadUserList()
    }
  },
  mounted: function () {
    if (this.properties.hasColumns) {
      if (this.properties.columns.cc) {
        this.columns.unshift({ key: 'cc', label: 'Código' })
      }
      if (this.properties.columns.grade) {
        this.columns.push({ key: 'grade', label: 'Grado' })
      }
      if (this.properties.columns.balance) {
        this.columns.push({ key: 'balance', label: 'Saldo' })
      }
      if (this.properties.columns.actions) {
        this.columns.push({ key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' })
      }
    }
    if (!this.properties.create) {
      this.form.visibleCollapse = true
    }
  },
}
</script>
